// extracted by mini-css-extract-plugin
export var disabled = "_1o-a";
export var hierarchyLinkGray = "_1o-4";
export var hierarchyLinkUnderline = "_1o-3";
export var hierarchyPrimary = "_1o-0";
export var hierarchySecondary = "_1o-1";
export var hierarchyTertiary = "_1o-2";
export var pressed = "_1o-6";
export var themeAction = "_1o-5";
export var themeDestructive = "_1o-8";
export var themeNormal = "_1o-7";
export var themeSuccess = "_1o-9";